/* eslint-disable */
import React from "react";
import styles from "./ExportModal.module.css";

const CHECK = <svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5" /></svg>;

// Single export-format card (Excel/CSV · PDF · JSON · Images by brand).
export function ExportFormatCard({ fmt, active, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`${styles.fmtCard} ${active ? styles.fmtCardSel : ""}`}
    >
      <span className={styles.fmtIcon}>{fmt.icon}</span>
      <span className={styles.fmtBody}>
        <span className={styles.fmtName}>{fmt.name}</span>
        <span className={styles.fmtDesc}>{fmt.desc}</span>
      </span>
      {active && <span className={styles.fmtCheck}>{CHECK}</span>}
    </button>
  );
}
